import Vue from 'vue'
import axios from '@axios'

// Реактивное состояние бэджа меню «Предложка»: '' скрывает бэдж (v-if="item.tag" в ядре Vuexy).
export const suggestionBadge = Vue.observable({ count: '' })

// Обновляет число pending-предложек. Ошибки глотаем: бэдж не критичен.
export const refreshSuggestionBadge = () => axios
    .get('/suggestion', { params: { status: 'pending', per_page: 1 } })
    .then(response => {
        suggestionBadge.count = response.data.total > 0 ? String(response.data.total) : ''
    })
    .catch(() => {})
